// Modules
import { useEffect, useState } from 'react'

/**
 * Hook Debounce
 * @param {T} value valor
 * @param {number} ms milisegundos
 * @returns {Object} valor y estado de carga
 */
export const useDebounce = <T>(value: T, ms: number) => {
    const [debounceValue, setDebounceValue] = useState<T>(value)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        const timeout = setTimeout(() => {
            setDebounceValue(value)
            setLoading(false)
        }, ms)

        return () => {
            clearTimeout(timeout)
        }
    }, [value, ms])

    return { value: debounceValue, loading }
}

